import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";



export const fetchLoaStats = createAsyncThunk("fetchLoaStats", async (data) => {
  try {
    const { startDate, endDate } = data;
    const response = await axiosInstance.get("/logs/loa_stats", {
      params: { start_date: startDate, end_date: endDate },
    //   headers: {
    //     Authorization: `Bearer ${localStorage.getItem("token")}`, // if protected route
    //   },
    });
    return response?.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Server Not Responding");
  }
});